import type { VehicleType } from '@autopass-web/types';

export const ENV =
  (process.env['NEXT_PUBLIC_APP_ENV'] as 'development' | 'production') ||
  'development';
export const CENTRAL_WINDOW_WIDTH = 360;
export const CENTRAL_WINDOW_HEIGHT = 220;
export const CENTRAL_WINDOW_ASPECT_RATIO =
  CENTRAL_WINDOW_WIDTH / CENTRAL_WINDOW_HEIGHT;

export const VEHICLE_TYPE_OPTIONS: VehicleType[] = [
  'car',
  'micro_electric_bike',
  'moto',
  'heavy_moto',
  'trailer',
];

const CONTACT_AUTOPASS_URLS = {
  development: 'https://www-alpha.pklotcorp.com/contact',
  production: 'https://www.autopass.xyz/contact',
} as const;

const LIFF_IDS = {
  development: '2007436918-Ea7KRoyO',
  production: '2007438735-eW61BX1P',
} as const;

const INSURANCE_URLS = {
  development: 'https://liff.line.me/2007436918-wgVmaek2',
  production: 'https://liff.line.me/2007438735-kKRVO6Vy',
};

const INSURANCE_CAR_PLANS_URLS = {
  development: 'https://liff.line.me/2007436918-n20vKDLJ',
  production: 'https://liff.line.me/2007438735-3BVAEdAQ',
};

// https://verifast-alpha.pklotcorp.com/
const VERIFAST_API_URLS = {
  development: 'https://verifast-api-alpha.pklotcorp.com',
  production: 'https://verifast-api.autopass.xyz',
};

const AMPLITUDE_API_KEYS = {
  development: '623278da0a3b7585e3c179c3cdd9434f',
  production: '02571facfa6576ef45efe76283dfb5cc',
};

const EXTERNAL_E_INSURANCE_URLS = {
  development: 'https://www-test.einsure.com.tw/service/external/autopass',
  production: 'https://www.einsure.com.tw/service/external/autopas',
};

export const LIFF_ID = LIFF_IDS[ENV] as string;
export const INSURANCE_URL = INSURANCE_URLS[ENV] as string;
export const INSURANCE_CAR_PLANS_URL = INSURANCE_CAR_PLANS_URLS[ENV] as string;
export const VERIFAST_API_URL = VERIFAST_API_URLS[ENV] as string;
export const AMPLITUDE_API_KEY = AMPLITUDE_API_KEYS[ENV] as string;
export const CONTACT_AUTOPASS_URL = CONTACT_AUTOPASS_URLS[ENV] as string;
export const EXTERNAL_E_INSURANCE_URL = EXTERNAL_E_INSURANCE_URLS[
  ENV
] as string;

export * from './path';
export * from './query-string-keys';
